import React, { useState, useEffect, useRef } from "react";
// eslint-disable-next-line
import { SketchPicker, CompactPicker } from "react-color";
import { TfMain } from "./Tfjs";
import { front, middle } from "./PythonCodeBase";
import ProgressBar from "./ProgressBar";

export default function BlockCode(props) {
  let fileReader;
  const [labels, setLabels] = useState(["클래스 1", "클래스 2"]);
  const [ch1OutputType, setCh1OutputType] = useState(0);
  const [ch2OutputType, setCh2OutputType] = useState(0);
  const [ch1OutputAmount, setCh1OutputAmount] = useState([]);
  const [ch2OutputAmount, setCh2OutputAmount] = useState([]);
  const [tfFunc, setTfFunc] = useState(null);
  // eslint-disable-next-line
  const [moveMotorThreshold, setMoveMotorThreshold] = useState(80);
  const [checkMove, setCheckMove] = useState(false);
  const [piboxUploadBtnName, setPiboxUploadBtnName] =
    useState("블록코드 업로드");
  const [checkTime, setCheckTime] = useState(0);
  const [probability, setProbability] = useState([0, 0]);
  const [dataCount, setDataCount] = useState([0, 0]);
  const camera = useRef("");
  // eslint-disable-next-line
  const piboxUploadBtn = useRef("");

  useEffect(() => {
    async function waitAndLoadingToFalse() {
      await wait(2.0);
      props.setLoadingToFalse();
    }
    if (camera.current !== undefined && props.machineId !== "") {
      setTfFunc(
        new TfMain(
          camera,
          props.machineId,
          props.ipAddress,
          setProbability,
          setDataCount
        )
      );
      setCh1OutputAmount(new Array(2).fill(""));
      setCh2OutputAmount(new Array(2).fill(""));
      waitAndLoadingToFalse();
    } // eslint-disable-next-line
  }, [camera, props.machineId]);

  const uploadFile = (file) => {
    // 파일이 입력되면 먼저 여기로 들어오게된다.
    // 파일입력이 없음에도 들어오면 바로 컷
    if (file === undefined) {
      return;
    }

    fileReader = new FileReader();

    fileReader.onloadend = () => {
      const content = fileReader.result;
      const result = [];
      content.split("\n").forEach((label) => {
        result.push(label.substr(2));
        console.log(label);
      });
      if (result[result.length - 1] === "") {
        result.pop();
      }
      setLabels(result);
      setCh1OutputType(0);
      setCh2OutputType(0);
      setCh1OutputAmount(new Array(result.length).fill(""));
      setCh2OutputAmount(new Array(result.length).fill(""));
    };
    fileReader.readAsText(file);
  };

  function addClass() {
    tfFunc.addClass();
    setLabels((state) => [...state, `클래스 ${labels.length + 1}`]);
    setCh1OutputAmount((state) => [...state, ""]);
    setCh2OutputAmount((state) => [...state, ""]);
    setProbability((state) => [...state, 0]);
  }

  function getSetOutput() {
    let setOutputContext = `GPIO.setmode(GPIO.BCM)
pwm = pigpio.pi() 
    `;
    // 서보모터
    if (ch1OutputType === 1)
      setOutputContext += `
pwm.set_mode(18, pigpio.OUTPUT)
`;
    else if (ch1OutputType === 2)
      setOutputContext += `
GPIO.setup(18,GPIO.OUT) # Channel 1 Speed
GPIO.setup(23,GPIO.OUT) # Direction of Channel 1
GPIO.output(23,0) 
m1=GPIO.PWM(18,50)
m1.start(0)
`;
    else if (ch1OutputType === 3 && ch2OutputType !== 3)
      setOutputContext += `
pix1 = neopixel.NeoPixel(board.D18,12)
`;
    // 서보모터
    if (ch2OutputType === 1)
      setOutputContext += `
pwm.set_mode(12, pigpio.OUTPUT)
`;
    else if (ch2OutputType === 2)
      setOutputContext += `
GPIO.setup(12,GPIO.OUT) # Channel 2 Speed
GPIO.setup(25,GPIO.OUT)
GPIO.output(25,0) # Direction of Channel 2
m2=GPIO.PWM(12,50)
m2.start(0)
`;
    else if (ch2OutputType === 3 && ch1OutputType !== 3)
      setOutputContext += `
pix2 = neopixel.NeoPixel(board.D12,12)
`;
    return setOutputContext;
  }
  function getIfContext() {
    let chk = 0;
    let context = `    # From here. the block code
    resultIndex = np.argmax(result)
`;
    labels.forEach((label, index) => {
      let func = "";
      let noOutputCh1 = false;
      let noOutputCh2 = false;
      // 타입이 0 이면 아웃풋이 없다.
      if (ch1OutputType === 0) noOutputCh1 = true;
      else if (ch1OutputType === 1) {
        // 타입이 1이면 서보모터 실행
        if (isNaN(parseFloat(ch1OutputAmount[index]))) noOutputCh1 = true;
        else
          func += `pwm.set_servo_pulsewidth(18,${
            (parseFloat(ch1OutputAmount[index]) / 180) * 2000 + 500
          }) # 500 => 0 deg / 1500 => 90 deg / 2500 => 180 deg
        `;
      }
      // 타입이 2면 DC모터
      else if (ch1OutputType === 2)
        func += `m1.ChangeDutyCycle(${ch1OutputAmount[index][1]})
        GPIO.output(23,${ch1OutputAmount[index][0]}) # Control direction
        ${
          ch2OutputType === 2
            ? ""
            : `time.sleep(${ch1OutputAmount[index][2]})
        m1.ChangeDutyCycle(0)
        GPIO.output(23,0)
        `
        }
        `;
      // LED
      else if (ch1OutputType === 3)
        func += `pix1.fill((${ch1OutputAmount[index].r},${ch1OutputAmount[index].g},${ch1OutputAmount[index].b}))
        pix1.show()
        `;
      // 서보모터
      else noOutputCh1 = true;
      if (ch2OutputType === 0) noOutputCh2 = true;
      else if (ch2OutputType === 1) {
        if (isNaN(parseFloat(ch2OutputAmount[index]))) noOutputCh2 = true;
        else
          func += `pwm.set_servo_pulsewidth(12,${
            (parseFloat(ch2OutputAmount[index]) / 180) * 2000 + 500
          }) # 500 => 0 deg / 1500 => 90 deg / 2500 => 180 deg
        `;
      }
      // DC모터
      else if (ch2OutputType === 2)
        func += `m2.ChangeDutyCycle(${ch2OutputAmount[index][1]})
        GPIO.output(25,${ch2OutputAmount[index][0]}) # Control direction
        time.sleep(${ch2OutputAmount[index][2]})
        ${
          ch1OutputType === 2
            ? `m1.ChangeDutyCycle(0)
        GPIO.output(23,0)`
            : ""
        }
        m2.ChangeDutyCycle(0)
        GPIO.output(25,0)
        `;
      // LED
      else if (ch2OutputType === 3)
        func += `pix2.fill((${ch2OutputAmount[index].r},${ch2OutputAmount[index].g},${ch2OutputAmount[index].b}))
        pix2.show()
        `;
      // 아무것도 없다
      else noOutputCh2 = true;
      if (noOutputCh1 === true && noOutputCh2 === true) return;
      if (
        (ch1OutputType !== 0 && ch1OutputAmount[index] !== "") ||
        (ch2OutputType !== 0 && ch2OutputAmount[index] !== "")
      ) {
        if (chk === 0) {
          context += `
    if `;
          chk = 1;
        } else {
          context += `
    elif `;
        }
      }
      context += `resultIndex == ${index}:
        ${func}
        `;
    });
    return context;
  }
  function getBackContext() {
    let back = `
# Clean up
cv2.destroyAllWindows()
videostream.stop()
`;

    if (ch1OutputType === 1 || ch2OutputType === 1) {
      back += `pwm.stop()
`;
    }
    if (ch1OutputType === 2) {
      back += `m1.stop()
`;
    }
    if (ch2OutputType === 2) {
      back += `m2.stop()
`;
    }
    back += `GPIO.cleanup()
`;
    return back;
  }
  const downloadPy = async () => {
    //piboxUploadBtn.current.disabled = true;
    setPiboxUploadBtnName("잠시만 기다려주세요...");
    props.setLoadingToTrue();
    const isModel = await tfFunc.download();
    if (!isModel) {
      setPiboxUploadBtnName("블록코드 업로드");
      props.setLoadingToFalse();
      return;
    }
    //const element = document.createElement("a");
    const front2 = getSetOutput();
    const middleIf = getIfContext();
    const back = getBackContext();
    const file = new Blob([front, front2, middle, middleIf, back], {
      type: "text/plain",
    });
    // element.href = URL.createObjectURL(file);
    // element.download = "pibox.py";
    // document.body.appendChild(element); // Required for this to work in FireFox
    //element.click();
    const piForm = new FormData();
    piForm.append("pibox", file, "pibox.py");
    try {
      fetch("http://tfjson-to-tflite.unicityclean.com/pibox", {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          machine_id: props.machineId,
        },
        redirect: "follow", // manual, *follow, error
        referrer: "no-referrer", // no-referrer, *client
        body: piForm,
      })
        .then(() => {
          props.sendCommand(props.uploadUUID);
        })
        .then(() => {
          props.setLoadingToFalse();
          setPiboxUploadBtnName("블록코드 업로드");
          alert(
            "업로드가 완료되었습니다. 잠시 기다렸다가 PLAi 실행을 해주세요."
          );
          //piboxUploadBtn.current.disabled = false;
        });
    } catch (error) {
      console.log(error);
      props.setLoadingToFalse();
      alert("업로드 실패, 나중에 다시 시도해주세요.");
      setPiboxUploadBtnName("블록코드 업로드");
      //piboxUploadBtn.current.disabled = false;
    }

    return file;
  };

  //   function downloadBat(os) {
  //     const element = document.createElement("a");
  //     const batText = `sshpass -praspberry scp -o StrictHostKeyChecking=no ./model.tflite pi@${props.ipAddress}:/home/pi/tflite/model.tflite
  // sshpass -praspberry scp -o StrictHostKeyChecking=no ./labels.txt pi@${props.ipAddress}:/home/pi/tflite/labels.txt
  // sshpass -praspberry scp -o StrictHostKeyChecking=no ./pibox.py pi@${props.ipAddress}:/home/pi/tflite/pibox.py
  // `;
  //     const file = new Blob([batText], {
  //       type: "text/plain",
  //     });
  //     element.href = URL.createObjectURL(file);
  //     element.download = os === "WIN" ? "upload.bat" : "upload.sh";
  //     document.body.appendChild(element); // Required for this to work in FireFox
  //     element.click();
  //   }

  const sendLEDoff = async (index) => {
    const url = "http://" + props.ipAddress + ":8000/move.html?";
    let ch1Command = "None";
    if (ch1OutputType === 3) {
      switch (ch1OutputType) {
        case 3:
          ch1Command = "led_" + 0 + "_" + 0 + "_" + 0;
          break;
        default:
          break;
      }
    }
    let ch2Command = "None";
    if (ch2OutputType === 3) {
      switch (ch2OutputType) {
        case 3:
          ch2Command =
            "led_" +
            ch2OutputAmount[index].r +
            "_" +
            ch2OutputAmount[index].g +
            "_" +
            ch2OutputAmount[index].b;
          break;
        default:
          break;
      }
    }
    //console.log(ch2OutputType, ch2OutputAmount);
    console.log(url + "ch1=" + ch1Command + "&ch2=" + ch2Command);
    try {
      await fetch(url + "ch1=" + ch1Command + "&ch2=" + ch2Command);
    } catch (error) {
      console.log(error);
    }
    setCheckTime(Date.now());
  };

  const sendMoving = (index) => {
    if ((ch1OutputType === 2 || ch2OutputType === 2) && 0) {
      alert("지금은 서보모터와 LED만 동작해 볼 수 있습니다!");
    } else {
      if (checkTime + 2000 < Date.now()) {
        const url = "http://" + props.ipAddress + ":8000/move.html?";
        let ch1Command = "None";
        if (
          (!isNaN(parseFloat(ch1OutputAmount[index])) && ch1OutputType === 1) ||
          (!isNaN(parseFloat(ch1OutputAmount[index][2])) &&
            ch1OutputType === 2) ||
          (!isNaN(parseFloat(ch1OutputAmount[index].r)) && ch1OutputType === 3)
        ) {
          switch (ch1OutputType) {
            case 1:
              ch1Command = "servo_" + ch1OutputAmount[index];
              break;
            case 2:
              ch1Command =
                "dc_" +
                ch1OutputAmount[index][1] +
                "_" +
                ch1OutputAmount[index][0] +
                "_" +
                ch1OutputAmount[index][2];
              break;
            case 3:
              ch1Command =
                "led_" +
                ch1OutputAmount[index].r +
                "_" +
                ch1OutputAmount[index].g +
                "_" +
                ch1OutputAmount[index].b;
              break;
            default:
              break;
          }
        }
        let ch2Command = "None";
        if (
          (!isNaN(parseFloat(ch2OutputAmount[index])) && ch2OutputType === 1) ||
          (!isNaN(parseFloat(ch2OutputAmount[index][2])) &&
            ch2OutputType === 2) ||
          (!isNaN(parseFloat(ch2OutputAmount[index].r)) && ch2OutputType === 3)
        ) {
          switch (ch2OutputType) {
            case 1:
              ch2Command = "servo_" + ch2OutputAmount[index];
              break;
            case 2:
              ch2Command =
                "dc_" +
                ch2OutputAmount[index][1] +
                "_" +
                ch2OutputAmount[index][0] +
                "_" +
                ch2OutputAmount[index][2];
              break;
            case 3:
              ch2Command =
                "led_" +
                ch2OutputAmount[index].r +
                "_" +
                ch2OutputAmount[index].g +
                "_" +
                ch2OutputAmount[index].b;
              break;
            default:
              break;
          }
        }
        //console.log(ch2OutputType, ch2OutputAmount);
        console.log(url + "ch1=" + ch1Command + "&ch2=" + ch2Command);
        try {
          fetch(url + "ch1=" + ch1Command + "&ch2=" + ch2Command);
        } catch (error) {
          console.log(error);
        }
        setCheckTime(Date.now());
      }
    }
  };

  useInterval(() => {
    if (checkMove) {
      if ((ch1OutputType === 2 || ch2OutputType === 2) && 0) {
        alert("지금은 서보모터와 LED만 동작할 수 있습니다!");
        setCheckMove(false);
      } else {
        if (
          moveMotorThreshold <= tfFunc.resultConfidence &&
          tfFunc.result !== -1
        ) {
          sendMoving(tfFunc.result);
        }
      }
    }
  }, 100);

  const selectOutputMount = (index) => (
    <div className="showOutputType" key={index}>
      <span>
        <div
          className="class-object-label"
          style={{ marginTop: "9px", marginBottom: "10px" }}
        >
          출력 1
        </div>
        {ch1OutputType === 1 ? (
          <div className="servomotor">
            <p>
              모터의 날개가 움직이는 각도를 설정해주세요.
              <br /> ( 0 ~ 180 )
            </p>
            <input
              style={{ height: 30 }}
              onChange={(e) => {
                let value = e.target.value;
                setCh1OutputAmount((state) => {
                  const newState = [...state];
                  newState[index] = value > 180 ? 180 : value < 0 ? 0 : value;
                  return newState;
                });
              }}
              type="number"
              value={ch1OutputAmount[index] || ""}
            />
          </div>
        ) : ch1OutputType === 2 ? (
          <div style={{ display: "inline" }}>
            <select
              style={{
                backgroundColor: "#ffffff",
                fontSize: 15,
                borderRadius: 2,
              }}
              onChange={(e) => {
                const value = e.target.value;
                setCh1OutputAmount((state) => {
                  const newState = [...state];
                  newState[index] = [
                    value,
                    newState[index][1],
                    newState[index][2],
                  ];
                  return newState;
                });
              }}
              defaultValue={ch1OutputAmount[index][0]}
            >
              <option value="0">정방향</option>
              <option value="1">역방향</option>
            </select>
            <div style={{ display: "flex" }}>
              <div>
                <h5 style={{ textAlign: "center" }}>속도 ( 0 ~ 100 ) </h5>
                <input
                  style={{ height: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCh1OutputAmount((state) => {
                      const newState = [...state];
                      newState[index] = [
                        newState[index][0],
                        value,
                        newState[index][2],
                      ];
                      return newState;
                    });
                  }}
                  type="number"
                  value={ch1OutputAmount[index][1]}
                />
              </div>
              <div style={{ marginLeft: "10%" }}>
                <h5 style={{ textAlign: "center" }}>시간 ( 1 {"=>"} 1초 ) </h5>
                <input
                  style={{ height: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCh1OutputAmount((state) => {
                      const newState = [...state];
                      newState[index] = [
                        newState[index][0],
                        newState[index][1],
                        value,
                      ];
                      return newState;
                    });
                  }}
                  type="number"
                  value={ch1OutputAmount[index][2]}
                />
              </div>
            </div>
          </div>
        ) : ch1OutputType === 3 ? (
          <div style={{ display: "inline" }}>
            <CompactPicker //SketchPicker
              color={ch1OutputAmount[index]}
              onChange={(value) => {
                setCh1OutputAmount((state) => {
                  console.log(value.rgb.r);
                  console.log(state);
                  const newState = [...state];
                  newState[index] = value.rgb;
                  return newState;
                });
              }}
            />
          </div>
        ) : (
          <div style={{ padding: "10px" }}>출력 종류를 먼저 선택하세요</div>
        )}
      </span>
      <span>
        <div
          className="class-object-label"
          style={{ marginTop: "9px", marginBottom: "10px" }}
        >
          출력 2
        </div>
        {ch2OutputType === 1 ? (
          <div className="servomotor">
            <p>
              모터의 날개가 움직이는 각도를 설정해주세요.
              <br />( 0 ~ 180 )
            </p>
            <input
              style={{ height: 30 }}
              onChange={(e) => {
                let value = e.target.value;
                setCh2OutputAmount((state) => {
                  const newState = [...state];

                  newState[index] = value > 180 ? 180 : value < 0 ? 0 : value;
                  return newState;
                });
              }}
              type="number"
              value={ch2OutputAmount[index] || ""}
            />
          </div>
        ) : ch2OutputType === 2 ? (
          <div style={{ display: "inline" }}>
            <select
              style={{
                backgroundColor: "#ffffff",
                fontSize: 15,
                borderRadius: 2,
              }}
              onChange={(e) => {
                const value = e.target.value;
                setCh2OutputAmount((state) => {
                  const newState = [...state];
                  newState[index] = [
                    value,
                    newState[index][1],
                    newState[index][2],
                  ];
                  return newState;
                });
              }}
              defaultValue={ch2OutputAmount[index][0]}
            >
              <option value="0">정방향</option>
              <option value="1">역방향</option>
            </select>
            <div style={{ display: "flex" }}>
              <div>
                <h5 style={{ textAlign: "center" }}>속도 ( 0 ~ 100 ) </h5>
                <input
                  style={{ height: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCh2OutputAmount((state) => {
                      const newState = [...state];
                      newState[index] = [
                        newState[index][0],
                        value,
                        newState[index][2],
                      ];
                      return newState;
                    });
                  }}
                  type="number"
                  value={ch2OutputAmount[index][1]}
                />
              </div>
              <div style={{ marginLeft: "10%" }}>
                <h5 style={{ textAlign: "center" }}>시간 ( 1 {"=>"} 1초 ) </h5>
                <input
                  style={{ height: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCh2OutputAmount((state) => {
                      const newState = [...state];
                      newState[index] = [
                        newState[index][0],
                        newState[index][1],
                        value,
                      ];
                      return newState;
                    });
                  }}
                  type="number"
                  value={ch2OutputAmount[index][2]}
                />
              </div>
            </div>
          </div>
        ) : ch2OutputType === 3 ? (
          <div style={{ display: "inline" }}>
            <CompactPicker
              color={ch2OutputAmount[index]}
              onChangeComplete={(value) => {
                setCh2OutputAmount((state) => {
                  const newState = [...state];
                  newState[index] = value.rgb;
                  return newState;
                });
              }}
            />
          </div>
        ) : (
          <div style={{ padding: "10px" }}>출력 종류를 먼저 선택하세요</div>
        )}
      </span>
      <span>
        <button className="test-move" onClick={() => sendMoving(index)}>
          테스트하기
        </button>
      </span>
    </div>
  );

  const selectOutputType = () => (
    <div
      className="blocks"
      style={{ display: "inline", width: "49%", marginLeft: "1%" }}
    >
      <div className="block" id="output-type-block">
        <div className="output-type">
          <div className="Out-put-01">출력 1</div>
          <div className="output-circles">
            <div
              style={{ marginLeft: "12%" }}
              onClick={() => {
                if (ch1OutputType === 1) {
                  setCh1OutputType(0);
                  setCh1OutputAmount((state) => {
                    return new Array(state.length).fill("");
                  });
                } else {
                  setCh1OutputType(1);
                  setCh1OutputAmount((state) => {
                    return new Array(state.length).fill("0");
                  });
                }
              }}
            >
              <img
                width="76"
                height="76"
                src={
                  ch1OutputType === 1
                    ? "img/servomotor_picked.svg"
                    : "img/servomotor.svg"
                }
                alt="servomotor"
                style={{ cursor: "pointer" }}
              />
            </div>

            <div
              style={{ marginLeft: "40px", marginRight: "40px" }}
              onClick={() => {
                if (ch1OutputType === 2) {
                  setCh1OutputType(0);
                  setCh1OutputAmount((state) => {
                    return new Array(state.length).fill("");
                  });
                } else {
                  setCh1OutputType(2);
                  setCh1OutputAmount((state) => {
                    return new Array(state.length).fill(["0", "50", "0.5"]);
                  });
                }
              }}
            >
              <img
                width="76"
                height="76"
                style={{ cursor: "pointer" }}
                src={
                  ch1OutputType === 2
                    ? "img/dcmotor_picked.svg"
                    : "img/dcmotor.svg"
                }
                alt="dcmotor"
              />
            </div>

            <div
              style={{ marginRight: "12%" }}
              onClick={() => {
                if (ch1OutputType === 3) {
                  setCh1OutputType(0);
                  setCh1OutputAmount((state) => {
                    return new Array(state.length).fill("");
                  });
                } else {
                  if (ch2OutputType !== 3) {
                    setCh1OutputType(3);
                    setCh1OutputAmount((state) => {
                      return new Array(state.length).fill({
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1,
                      });
                    });
                  } else {
                    alert("LED 출력은 1개의 채널만 가능합니다.");
                  }
                }
              }}
            >
              <img
                width="76"
                height="76"
                style={{ cursor: "pointer" }}
                src={ch1OutputType === 3 ? "img/led_picked.svg" : "img/led.svg"}
                alt="led"
              />
            </div>
          </div>
        </div>
        <div className="output-type" style={{ marginLeft: "80px" }}>
          <div className="Out-put-01">출력 2</div>
          <div className="output-circles">
            <div
              style={{ marginLeft: "12%" }}
              onClick={() => {
                if (ch2OutputType === 1) {
                  setCh2OutputType(0);
                  setCh2OutputAmount((state) => {
                    return new Array(state.length).fill("");
                  });
                } else {
                  setCh2OutputType(1);
                  setCh2OutputAmount((state) => {
                    return new Array(state.length).fill("0");
                  });
                }
              }}
            >
              <img
                width="76"
                height="76"
                style={{ cursor: "pointer" }}
                src={
                  ch2OutputType === 1
                    ? "img/servomotor_picked.svg"
                    : "img/servomotor.svg"
                }
                alt="servomotor"
              />
            </div>

            <div
              style={{ marginLeft: "40px", marginRight: "40px" }}
              onClick={() => {
                if (ch2OutputType === 2) {
                  setCh2OutputType(0);
                  setCh2OutputAmount((state) => {
                    return new Array(state.length).fill("");
                  });
                } else {
                  setCh2OutputType(2);
                  setCh2OutputAmount((state) => {
                    return new Array(state.length).fill(["0", "50", "0.5"]);
                  });
                }
              }}
            >
              <img
                width="76"
                height="76"
                style={{ cursor: "pointer" }}
                src={
                  ch2OutputType === 2
                    ? "img/dcmotor_picked.svg"
                    : "img/dcmotor.svg"
                }
                alt="dcmotor"
              />
            </div>

            <div
              style={{ marginRight: "12%" }}
              onClick={() => {
                if (ch2OutputType === 3) {
                  setCh2OutputType(0);
                  setCh2OutputAmount((state) => {
                    return new Array(state.length).fill("");
                  });
                } else {
                  if (ch1OutputType !== 3) {
                    setCh2OutputType(3);
                    setCh2OutputAmount((state) => {
                      return new Array(state.length).fill({
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1,
                      });
                    });
                  } else {
                    alert("LED 출력은 1개의 채널만 가능합니다.");
                  }
                }
              }}
            >
              <img
                width="76"
                height="76"
                style={{ cursor: "pointer" }}
                src={ch2OutputType === 3 ? "img/led_picked.svg" : "img/led.svg"}
                alt="dcmotor"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const wait = async (sec) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, 1000 * sec);
    });
  };

  const cameraPreviewWithButtons = () => (
    //아웃풋 종류 보여줌
    <div className="sticky-block">
      <div className="block-2">
        <div className="block" ref={camera}></div>
        <div style={{ marginLeft: "20px" }}>
          <img
            width="224"
            height="54"
            alt="train"
            src="img/plai_train.svg"
            id="trainButton"
            onClick={async () => {
              props.setLoadingToTrue();
              await wait(0.5);
              tfFunc.train(props.setLoadingToFalse);
            }}
            className="plai-train"
          />
        </div>
        <div style={{ marginLeft: "20px" }}>
          <img
            width="224"
            height="54"
            alt="checkMove"
            style={{ cursor: "pointer" }}
            src={checkMove ? "img/plai_move_on.svg" : "img/plai_move_off.svg"}
            onClick={() => setCheckMove(!checkMove)}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="connect-panel panel">
      <img
        alt="goback"
        onClick={async () => {
          await sendLEDoff();
          props.setIsBlockCoding();
        }}
        src="img/icon_arrow_back.svg"
        className="Icon-arrow_back-blockcode"
      ></img>
      {false ? (
        <div>
          <p>
            라벨 :{" "}
            <input
              type="file"
              accept=".txt"
              onChange={(e) => uploadFile(e.target.files[0])}
            />
          </p>
        </div>
      ) : null}
      {/* <div className="training-label">학습하기</div> */}
      <div style={{ display: "flex" }}>
        <div style={{ width: "32.3%", marginLeft: "4%" }}>
          {cameraPreviewWithButtons()}
        </div>
        <div style={{ width: "67.7%", marginRight: "4%" }}>
          <div>{selectOutputType()}</div>
          <div className="label-output">
            <div className="blocks-container">
              <div>
                {labels.map((label, index) => (
                  <div key={label}>
                    <div className="class-object">
                      <div className="class-object-left">
                        <div className="block">
                          <span className="class-object-label">{label}</span>
                          <ProgressBar
                            bgcolor={"#00695c"}
                            completed={Math.floor(probability[index] * 100)}
                          />
                        </div>
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                              position: "relative",
                              top: "70px",
                              flex: "1",
                            }}
                          >
                            <img
                              alt="addData"
                              src="img/icon_video.svg"
                              className="Icon-awesome-video"
                              onMouseDown={() => {
                                tfFunc.addTrainingData(index);
                              }}
                              onMouseUp={() => {
                                tfFunc.addTrainingData(-1);
                              }}
                              onTouchStart={() => {
                                tfFunc.addTrainingData(index);
                              }}
                              onMouseLeave={() => {
                                tfFunc.addTrainingData(-1);
                              }}
                              onTouchEnd={() => {
                                tfFunc.addTrainingData(-1);
                              }}
                              onTouchMove={() => {
                                tfFunc.addTrainingData(-1);
                              }}
                              onTouchCancel={() => {
                                tfFunc.addTrainingData(-1);
                              }}
                            ></img>
                            <span
                              className="class-object-data-count"
                              draggable="false"
                            >
                              {dataCount[index]}
                            </span>
                            <span
                              className="class-object-remove-data"
                              onClick={() => {
                                tfFunc.removeTrainingData(index);
                              }}
                            >
                              <img
                                width="55px"
                                height="55px"
                                alt="addData"
                                src="img/trash.png"
                              ></img>
                            </span>
                          </div>
                          <div
                            className="training-images"
                            id={"canvas-" + index.toString()}
                          ></div>
                        </div>
                      </div>
                      <hr
                        size="2"
                        width="60px"
                        noshade="true"
                        className="class-object-connecting"
                      ></hr>
                      <div className="class-object-right">
                        <span className="class-output-settings">
                          {selectOutputMount(index)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="block" style={{ textAlign: "center" }}>
        <img
          alt="addClass"
          style={{ margin: "0px auto", marginTop: "30px", cursor: "pointer" }}
          onClick={() => addClass()}
          src="img/add_class.svg"
        ></img>
      </div>
      <div className="block">
        <img
          alt="upload"
          style={{ margin: "0px auto", marginTop: "30px", cursor: "pointer" }}
          onClick={() =>
            piboxUploadBtnName !== "잠시만 기다려주세요..."
              ? downloadPy()
              : null
          }
          src={
            piboxUploadBtnName === "잠시만 기다려주세요..."
              ? "img/blockcode_uploading_button.svg"
              : "img/blockcode_upload_button.svg"
          }
        ></img>
      </div>
      {/* <div>
        <h4>
          블록이 완성되었다면{" "}
          <span style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadPy()}>
            코드 다운로드
          </span>{" "}
        </h4>
      </div> */}
      {/* <div>
        <h4>
          <span style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadBat("WIN")}>
            코드 업로드 프로그램(윈도우)
          </span>
          <br />
          코드와 업로드 프로그램 파일은 모델파일을 압축푼 폴더와 같은 폴더에 넣어주세요.
        </h4>
        <p>
          초기 비밀번호 : raspberry
          <br />
        </p>
      </div> */}
    </div>
  );
}

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
